(function () {
    'use strict';

    angular.module("imApp").factory("factsEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getFactsEdit: function (parms) {
                return $ihttp.post({
                    method: 2920,
                    parameters: parms || {}
                });
            },
            listValueTypes: function (parms) {
                return $ihttp.post({
                    method: 2921,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2922,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2923,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
